import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, Eye, Heart } from "lucide-react";

const DIFFICULTY_COLOR = {
  Principiante: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  Intermedio: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  Avanzado: "bg-rose-500/10 text-rose-400 border-rose-500/20",
};

export function ArticleCard({ article }) {
  return (
    <Link to={`/kb/article/${article.slug}`}>
      <Card className="h-full border-border/50 bg-card hover:border-accent/30 hover:shadow-card transition-all duration-200 group">
        <CardContent className="p-5">
          <h3 className="font-semibold text-sm text-foreground group-hover:text-accent transition-colors line-clamp-2">
            {article.title}
          </h3>
          <p className="text-xs text-muted-foreground mt-2 line-clamp-2 leading-relaxed">
            {article.summary || article.content?.slice(0, 120)}
          </p>

          <div className="flex items-center gap-2 mt-3 flex-wrap">
            {article.difficulty && (
              <Badge variant="outline" className={`text-[10px] ${DIFFICULTY_COLOR[article.difficulty]}`}>
                {article.difficulty}
              </Badge>
            )}
            {article.estimated_minutes && (
              <span className="flex items-center gap-1 text-[10px] text-muted-foreground">
                <Clock className="h-3 w-3" /> {article.estimated_minutes} min
              </span>
            )}
          </div>

          <div className="flex items-center justify-between mt-4 pt-3 border-t border-border/30">
            <span className="text-[11px] text-muted-foreground truncate max-w-[60%]">
              {article.author}
            </span>
            <div className="flex items-center gap-3 text-[10px] text-muted-foreground">
              {article.views > 0 && (
                <span className="flex items-center gap-1"><Eye className="h-3 w-3" />{article.views}</span>
              )}
              {article.favorites > 0 && (
                <span className="flex items-center gap-1"><Heart className="h-3 w-3" />{article.favorites}</span>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
